import { createSelector } from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.fetchLeasingCompanies);
export const getFormattedLeasingCompanies = createSelector(getState, ({leasingCompanies}) => {
  const leasingList = leasingCompanies.map(e => ({value: e.name, display: e.name}));
  leasingList.splice(0, 0, {value: null, display: ''});
  return leasingList;
});
export const isLoadingLeasingCompanies = createSelector(getState, ({loading}) => loading);



// WEBPACK FOOTER //
// ./src/selectors/leasingCompanies.js